// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js","771":"component---src-pages-page-2-js"}[chunkId] || chunkId) + "-" + {"125":"153049aba2885f7ff908","293":"ae4586e17beafe133500","522":"2b4b654231d5a376760f","771":"fdd6248be04cf8c541b4"}[chunkId] + ".js";
};